// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d64d91790d9378d3b32b","655":"0a979ecf1d19b060032b"}[chunkId] + ".js";
};